const HIDE_PAYMENT_BUTTON_FOR_STATUS = ['VOID', 'PAID'];

const PAYMENT_METHODS = [
  {
    integrationId: 'STRIPE',
    icon: 'Stripe.svg',
    title: 'admin.integrations.stripe.title',
    url: '/onboard/integrations/STRIPE'
  },
  {
    integrationId: 'FLEXPOINT',
    icon: 'FlexPoint.svg',
    title: 'admin.integrations.flexPoint.title',
    url: '/onboard/integrations/FLEXPOINT',
    ldFlag: 'flexPoint'
  },
  {
    integrationId: 'ALTERNATIVE_PAYMENTS',
    icon: 'AlternativePayments.svg',
    title: 'admin.integrations.alternativePayments.title',
    url: '/onboard/integrations/ALTERNATIVE_PAYMENTS',
    ldFlag: 'alternativePayments'
  }
];

const ERROR_CODES_ITEM_MAP = {
  3325: 'taxes',
  3326: 'items'
};

const invoiceColumns = () => [
  {
    name: 'invoiceId',
    label: 'client.navigation.invoice.list.invoiceId',
    dataType: getDataType('invoiceId'),
    filterType: getFilterType('invoiceId')
  },
  {
    name: 'invoiceDate',
    label: 'client.navigation.invoice.list.invoiceDate',
    dataType: 'daterange',
    filterType: getFilterType('invoiceDate')
  },
  {
    name: 'client.name',
    label: 'client.navigation.invoice.list.client',
    dataType: getDataType('client.name'),
    filterType: getFilterType('client.name')
  },
  {
    name: 'site.name',
    label: 'client.navigation.invoice.list.site',
    dataType: getDataType('site.name'),
    filterType: getFilterType('site.name')
  },
  {
    name: 'totalAmount',
    label: 'client.navigation.invoice.list.amount',
    dataType: getDataType('totalAmount'),
    filterType: getFilterType('totalAmount')
  },
  {
    name: 'statusEnum',
    label: 'common.status',
    dataType: getDataType('statusEnum'),
    filterType: getFilterType('statusEnum')
  },
  {
    name: 'paymentDate',
    label: 'attribute.paymentDate',
    dataType: 'daterange',
    filterType: getFilterType('paymentDate')
  },
  {
    name: 'paymentMethod.paymentMethodName',
    label: 'invoice.details.payment.method',
    dataType: getDataType('paymentMethod.paymentMethodName'),
    filterType: getFilterType('paymentMethod.paymentMethodName')
  },
  {
    label: 'invoice.details.paymentTerm',
    name: 'invoicePaymentTerm.paymentTermName',
    dataType: getDataType('invoicePaymentTerm.paymentTermName'),
    filterType: getFilterType('invoicePaymentTerm.paymentTermName')
  }
];

// TODO: If a property is changed in invoiceColumns, check from personalisation and overwrite

const getInvoiceAuditColumns = (personalizedColumns, intl) => {
  const columnsFromLocal = invoiceColumns();
  const columnsFromPersonalization = personalizedColumns;
  let updatedColumns =
    (columnsFromPersonalization && [...columnsFromPersonalization]) ||
    columnsFromLocal;
  let addedColumns;
  if (
    columnsFromPersonalization &&
    columnsFromPersonalization.length !== columnsFromLocal.length
  ) {
    const result = getParsedCrudData(
      columnsFromPersonalization,
      columnsFromLocal,
      'name'
    );

    addedColumns = result.addedItems.map((el, idx) => {
      const indexInDefaultColumns = columnsFromLocal.findIndex(
        (col) => col.name === el.name
      );
      return {
        ...el,
        index: indexInDefaultColumns
      };
    });

    if (addedColumns) {
      // eslint-disable-next-line for-direction
      for (let i = 0; i < addedColumns.length; i++) {
        const item = { ...addedColumns[i] };
        delete item.index;
        updatedColumns.splice(addedColumns[i].index, 0, item);
      }
    }
  }

  // TODO: Can add deleted column logic

  updatedColumns = updatedColumns.map((el) => {
    const { dataType, filterType } = columnsFromLocal.find(
      (col) => col?.name === el?.name
    );
    return {
      ...el,
      dataType,
      filterType,
      label: getTranslatedText(intl, el.label)
    };
  });
  return updatedColumns;
};

export {
  getInvoiceAuditColumns,
  HIDE_PAYMENT_BUTTON_FOR_STATUS,
  PAYMENT_METHODS,
  ERROR_CODES_ITEM_MAP
};
